import React from 'react';
import { Button } from '../../Atoms';
function TemplateSimulateurRembourcementScreen4(props) {
    return (
        <>  
        {props.unkownPrice && 
            <div className='text-big-container-simulateur-remboursement' >
                <div className='text-container-simulateur-remboursement' >
                    Nous ne pouvons pas vous donner un montant exact de remboursement car vous ne connaissez pas le montant de vos soins.
                </div>
                <div className='text-container-simulateur-remboursement' >
                    Afin de vous aider à y voir plus clair, vous trouverez ci-dessous une fiche reprennant
                    <span> les tarifs moyens à l’échelle nationale.</span>
                </div>
            </div>
            }
            <div className='btn-next-container-simulateur-remboursement'>
                <Button
                    text='Télécharger le document'
                    className={'btn-download-simulateur-remboursement'}
                />
            </div>
        </>

    );
}

export default TemplateSimulateurRembourcementScreen4;
